import React from 'react'

import Viewer from '../viewer'

export default () => {
  return <Viewer />
}
